// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "a74cb9f-dirty",
    "hash": "a74cb9f",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "a74cb9f-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
